import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/bonuses';
export function BonusesSection() {
  return <section className="bg-zinc-950 px-5 py-20 md:py-28" data-id="element-67" data-mp="15arpb78jken8">
      <div className="mx-auto max-w-6xl" data-id="element-68" data-mp="qczbcjin7yb5">
        <div className="text-center" data-id="element-69" data-mp="qeaau7522jwg">
          <p className="font-display text-xl font-bold uppercase tracking-wide text-zinc-400 md:text-2xl" data-id="element-70" data-mp="vbu1y7muqr5t">No solo recibís los 6 volúmenes.</p>
          <h2 className="font-display mt-2 text-4xl font-extrabold uppercase leading-[1.05] text-zinc-50 md:text-6xl" data-id="element-71" data-mp="1j2fz33vbir11">
            También sumamos <span className="text-amber-400" data-id="element-72" data-mp="1o2kesroejhq7">5 bonos prácticos.</span>
          </h2>
          <div className="mx-auto mt-6 h-1 w-16 bg-amber-400" aria-hidden="true" data-id="element-73" data-mp="19b21j1mxg1aj" />
        </div>

        <ul className="mt-14 flex flex-wrap justify-center gap-5" data-id="element-74" data-mp="1e93mxt7tscp6">
          {bonuses.map(b => <li key={b.label} className="flex w-full flex-col rounded-xl border border-zinc-800 bg-zinc-900 p-7 sm:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.84rem)]" data-id="element-75" data-mp="21zh4uqwp4v61">
              <div className="flex items-center gap-2.5" data-id="element-76" data-mp="2m4z5zuf6d18o">
                <GiftIcon className="h-5 w-5 text-amber-400" aria-hidden="true" data-id="element-77" data-mp="2m3ecm84ljoce" />
                <p className="text-sm font-bold uppercase tracking-widest text-amber-400" data-id="element-78" data-mp="2h7z1hnxz46jo">{b.label}</p>
              </div>
              <h3 className="font-display mt-3 text-2xl font-extrabold uppercase leading-tight text-zinc-50 md:text-3xl" data-id="element-79" data-mp="2vxelml301dqe">{b.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-zinc-400 md:text-lg" data-id="element-80" data-mp="34vgv7p0stepa">{b.body}</p>
              <p className="mt-auto pt-5" data-id="element-81" data-mp="2zxf20b9nrz03">
                <span className="block border-t border-zinc-800 pt-4 text-xs font-bold uppercase tracking-wide text-amber-400 md:text-sm" data-id="element-82" data-mp="2zwdtoek11qm2">
                  {b.highlight}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}